import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import {
  casNumberField,
  hazardClassField,
  substanceOfConcernField,
} from './common/substanceFields';
import { massUnitField } from './common/sharedFields';

export const substanceInflowMetadata = {
  displayName: msg({
    message: 'Substance inflow',
    context: 'Activity data schema name for substance inflow',
  }),
  fields: {
    ...coreFields,
    cas_number: casNumberField,
    hazard_class: hazardClassField,
    quantity: {
      displayName: msg({
        message: 'Substance inflow',
        context: 'The quantity of the substance that enters the boundary.',
      }),
      externalDescription: msg({
        message: 'The quantity of the substance released.',
        context: 'Substance quantity',
      }),
    },
    substance_inflow_medium: {
      displayName: msg({
        message: 'Substance inflow medium',
        context: 'The medium through which the substance enters the boundary.',
      }),
      externalDescription: msg({
        message: 'The medium through which the substance enters the boundary.',
        context: 'Substance inflow medium',
      }),
    },
    substance_of_concern: substanceOfConcernField,
    unit: massUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
